var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"badge",attrs:{"href":_vm.hyperlink}},[_c('CustomIcon',{staticClass:"badge-image",attrs:{"name":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }